import { observable, action } from 'mobx'
import { Modal, message } from 'hljd'
import api from '@api/hotel/vr'
import { VR_FILTER_LIST } from './constant'

class Store {
  @observable originList = []
  @observable list = []
  @observable inputValue = ''
  @observable statusKey = VR_FILTER_LIST[0].value

  @action
  getHotelVrInfo = async () => {
    const {
      data: { list }
    } = await api.getPanoList({ page: 1, per_page: 2000 })
    if (list) {
      this.originList = list
      this.list = list
    }
  }

  @action
  deleteVrInfo = id => {
    // antd pagination传过来的索引是当前页的索引 用id处理更方便
    Modal.confirm({
      content: '确认删除吗？',
      onOk: async () => {
        const { success } = await api.postPanoDelete({ panoId: id })
        if (success) {
          this.originList = this.originList.filter(item => item.id !== id) // 过滤掉被删掉的一项 更新数组
          this.list = this.list.filter(item => item.id !== id)
          message.success('删除成功')
        }
      }
    })
  }

  @action
  searchByName = e => {
    const { value } = e.target
    this.inputValue = value
    const handler = item =>
      this.statusKey.split(',').includes(`${item.status}`) &&
      item.name.match(value)
    this.list = this.originList.filter(handler)
  }

  @action
  searchByStatus = value => {
    // 制作中和待审核(999,2)都算待审核
    this.statusKey = value
    const handler = item =>
      value.split(',').includes(`${item.status}`) &&
      item.name.match(this.inputValue)
    this.list = this.originList.filter(handler)
  }

  @action
  resetSearch = () => {
    this.list = this.originList.map(item => ({ ...item }))
  }
}

export default new Store()
